import { AlertCircle, Loader2, type LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

import { cn } from '@/shared/lib/cn';
import { Button } from '@/shared/ui/button';

/**
 * Estados padrão (F1-5). Existem para que carregando/vazio/erro tenham a mesma
 * cara em toda a aplicação — na V1 cada página inventava o seu.
 */

export function EstadoCarregando({ rotulo = 'Carregando...' }: { rotulo?: string }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-12 text-muted-foreground">
      <Loader2 className="w-8 h-8 animate-spin text-brand" />
      <p className="text-sm">{rotulo}</p>
    </div>
  );
}

export function EstadoVazio({
  icone: Icone = AlertCircle,
  titulo,
  descricao,
  acao,
  className,
}: {
  icone?: LucideIcon;
  titulo: string;
  descricao?: string;
  acao?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-2 py-12 text-center', className)}>
      <Icone className="w-12 h-12 text-muted-foreground/50" />
      <p className="text-sm font-medium text-foreground">{titulo}</p>
      {descricao && <p className="text-sm text-muted-foreground max-w-sm">{descricao}</p>}
      {acao && <div className="mt-2">{acao}</div>}
    </div>
  );
}

export function EstadoErro({
  titulo = 'Algo deu errado',
  descricao = 'Não conseguimos carregar esta informação. Tente novamente.',
  aoTentarDeNovo,
}: {
  titulo?: string;
  descricao?: string;
  aoTentarDeNovo?: () => void;
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-12 text-center">
      <AlertCircle className="w-12 h-12 text-destructive/70" />
      <p className="text-sm font-medium text-foreground">{titulo}</p>
      <p className="text-sm text-muted-foreground max-w-sm">{descricao}</p>
      {aoTentarDeNovo && (
        <Button variant="outline" size="sm" onClick={aoTentarDeNovo} className="mt-2">
          Tentar novamente
        </Button>
      )}
    </div>
  );
}
